import { t } from "i18next";

import { getIndustrialProcessWording } from "#shared/helpers/getIndustrialProcessWording";
import { IndustrialProcessSchema, IndustrialProcessType, MaterialGradeType } from "shared";

export const getProcessStepTitle = ({
  processStep,
  companyMachine,
  materialGrade,
}: {
  processStep: {
    industrialProcess: IndustrialProcessType;
    description?: string | null | undefined;
    index: number;
  };
  companyMachine: { machine: { name: string } } | undefined;
  materialGrade: MaterialGradeType | null | undefined;
}) => {
  const { industrialProcess, description, index } = processStep;

  if (
    industrialProcess === IndustrialProcessSchema.enum.OTHER ||
    industrialProcess === IndustrialProcessSchema.enum.CHIMIC_ENGRAVING
  ) {
    return (
      [companyMachine?.machine.name, description].filter(Boolean).join(" - ") ||
      getIndustrialProcessWording(industrialProcess)
    );
  }

  if (industrialProcess === IndustrialProcessSchema.enum.OUTSOURCING) {
    return description
      ? `Sous-traitance - ${description}`
      : getIndustrialProcessWording(processStep.industrialProcess);
  }

  if (industrialProcess === IndustrialProcessSchema.enum.PRODUCTS) {
    return description
      ? `Achat - ${description}`
      : getIndustrialProcessWording(processStep.industrialProcess);
  }

  if (industrialProcess === IndustrialProcessSchema.enum.MATERIAL) {
    return materialGrade
      ? t(`qrl.materialGrades.${materialGrade}`)
      : processStep.description || "Matière secondaire";
  }

  if (industrialProcess === IndustrialProcessSchema.enum.SIMPLE) {
    return description || `Étape ${index + 1}`;
  }

  if (industrialProcess === IndustrialProcessSchema.enum.CONTROL) {
    return description ? `${description}` : "Contrôle";
  }

  return description
    ? description
    : getIndustrialProcessWording(processStep.industrialProcess) || "";
};
